import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const SouCapitalArtigos = lazy(() => import('./Artigos'));
const SouCapitalBeneficios = lazy(() => import('./Beneficios'));
const SouCapitalBeneficioForm = lazy(() => import('./BeneficioForm'));
const BeneficioPublico = lazy(() => import('../Publico/BeneficioPublico'));
const BeneficiosPublico = lazy(() => import('../Publico/BeneficiosPublico'));
const SouCapitalUniversidade = lazy(() => import('./Universidade'));
const SouCapitalMeusCursos = lazy(() => import('./MeusCursos'));
const SouCapitalCursoView = lazy(() => import('./CursoView'));
const SouCapitalAulaView = lazy(() => import('./AulaView'));
const SouCapitalAdminTrilhas = lazy(() => import('./admin/AdminTrilhas'));
const SouCapitalAdminCursos = lazy(() => import('./admin/AdminCursos'));
const SouCapitalCursoForm = lazy(() => import('./admin/CursoForm'));

export const souCapitalRoutes: (RouteObject & { layout?: string })[] = [
    {
        path: '/sou-capital/beneficios',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalBeneficios />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/beneficios/novo',
        element: (
            <ProtectedRoute permission="soucapital.beneficios.manage">
                <SouCapitalBeneficioForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/beneficios/:id/editar',
        element: (
            <ProtectedRoute permission="soucapital.beneficios.manage">
                <SouCapitalBeneficioForm />
            </ProtectedRoute>
        ),
    },
    // Páginas públicas: sem ProtectedRoute e sem o layout do portal (§10 do escopo).
    // /beneficios é a vitrine institucional (todas as publicações compartilháveis);
    // /beneficio/:token é a leitura de uma publicação.
    {
        path: '/beneficios',
        element: <BeneficiosPublico />,
        layout: 'blank',
    },
    {
        path: '/beneficio/:token',
        element: <BeneficioPublico />,
        layout: 'blank',
    },
    {
        path: '/sou-capital/artigos',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalArtigos />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/universidade',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalUniversidade />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/meus-cursos',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalMeusCursos />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/universidade/curso/:id',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalCursoView />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/universidade/aula/:id',
        element: (
            <ProtectedRoute permission="soucapital.view">
                <SouCapitalAulaView />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/admin/trilhas',
        element: (
            <ProtectedRoute permission="soucapital.manage">
                <SouCapitalAdminTrilhas />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/admin/cursos',
        element: (
            <ProtectedRoute permission="soucapital.manage">
                <SouCapitalAdminCursos />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/admin/cursos/novo',
        element: (
            <ProtectedRoute permission="soucapital.manage">
                <SouCapitalCursoForm />
            </ProtectedRoute>
        ),
    },
    {
        path: '/sou-capital/admin/cursos/:id/editar',
        element: (
            <ProtectedRoute permission="soucapital.manage">
                <SouCapitalCursoForm />
            </ProtectedRoute>
        ),
    },
];
